import { render } from "./Index.vue?vue&type=template&id=beb01190&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=beb01190&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-beb01190"

export default script